import React from 'react';
import { ContainerFileDinhKem } from 'components/upload';
import { connect } from 'react-redux';
import moment from 'moment';
import { browserHistory } from 'react-router';
import { ShowIf } from 'components/utils';
import { Text, TextMessage } from 'components/tt-forms/common';

class KetQuaLapDuThaoCanBo extends React.Component {

  onClickClose() {
    browserHistory.goBack();
  }
  componentDidMount() {
    if (window.debug) {
      console.log('handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien/KetQuaLapDuThaoCanBo');
    }
  }
  render() {

    let ketLuanNoiDungKhieuNai = this.props.dataKetLuanNoiDungKhieuNai.filter(state => {
      return state.giaTri == this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ketLuanNoiDungKhieuNai
    });

    let ketQuaThucHien = this.props.dataKetQuaThucHien.filter(state => {
      return state.giaTri == this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaThucHienTheoDoi
    });
    let ketQuaGiaiQuyetDon = this.props.ketQuaGiaiQuyetDon.filter(state => {
      return state.giaTri == this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaXLDGiaiQuyet
    })
    let lb1 = this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
    let lb2 = this.props.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
    return (
      <section className="wrap-block">
        <div className="row pl10 pr10">
          <div className="col-100 no-gutter">
            <h3 className="txt-upper title-14 mt0 mb15 pl5 pr5">Báo cáo kết quả xác minh{lb2}</h3>
            <div className="col-100 no-gutter">
              <Text className="col-25" label={"Đơn vị "+lb1+":"} value={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.donViThamTraXacMinhInfo ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.donViThamTraXacMinhInfo.ten : ''} />
              <Text className="col-25" label="Thời gian báo cáo kết quả:" value={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanTTXM ? moment(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanTTXM).format('DD/MM/YYYY') : ''} />
              <Text className="col-25" label="Ngày báo cáo kết quả:" value={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayTraBaoCaoTTXM ? moment(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayTraBaoCaoTTXM).format('DD/MM/YYYY') : ''} />
            </div>
            <ShowIf condition={this.props.loaiDonGiaTri == 'DON_TO_CAO' && this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.giaHanGiaiQuyet}>
              <div>
                <div className="col-100">
                  <h3 className="text-12 txt-upper txt-bold mb10 mt0">Gia hạn xác minh nội dung tố cáo:</h3>
                </div>
                <Text className="col-25 mb15" label="Số quyết định gia hạn:" value={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.soQuyetDinhGiaHanGiaiQuyet ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.soQuyetDinhGiaHanGiaiQuyet : ''} />
                <Text className="col-25 mb15" label="Ngày ra quyết định:" value={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayRaQuyetDinhGiaHanGiaiQuyet ? moment(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayRaQuyetDinhGiaHanGiaiQuyet).format('DD/MM/YYYY') : ''} />
                <Text className="col-25 mb15" label="Gia hạn giải quyết đến ngày:" value={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanSauKhiGiaHanGiaiQuyet ? moment(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : ''} />
                <TextMessage className="col-100" label="Lý do gia hạn:" value={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.lyDoGiaHanGiaiQuyet ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.lyDoGiaHanGiaiQuyet : ''} />
              </div>
            </ShowIf>
          </div>
        </div>
        <div className="row pl15 pr15">
          <div className="wrap-big-line pt5 pb20">
            <span className="big-border"></span>
          </div>
          <ShowIf condition={this.props.thongTinXuLyGiaiQuyet && this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo && this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET'}>
            <div>
              <ShowIf condition={this.props.loaiDonGiaTri == 'DON_TO_CAO'}>
                <h3 className="txt-upper title-14 mt0 mb15">Quyết định giải quyết tố cáo</h3>
              </ShowIf>
              <ShowIf condition={this.props.loaiDonGiaTri == 'DON_KHIEU_NAI'}>
                <h3 className="txt-upper title-14 mt0 mb15">Quyết định giải quyết khiếu nại</h3>
              </ShowIf>
              <ShowIf condition={this.props.loaiDonGiaTri != 'DON_TO_CAO' && this.props.loaiDonGiaTri != 'DON_KHIEU_NAI'}>
                <h3 className="txt-upper title-14 mt0 mb15">Văn bản giải quyết kiến nghị, phản ánh</h3>
              </ShowIf>
              <div className="row pl10 pr10 mb15">
                <Text className="col-25 mb0-18" label="Số vụ:" value={String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.soVuGiaiQuyetKhieuNai)} />
                <Text label="Kết luận nội dung khiếu nại:" className="col-25" value={ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : ''} />
                <Text className="col-25 mb0-18" label="Kết quả khác:" value={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaGiaiQuyetKhac ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaGiaiQuyetKhac : ''} />
              </div>

              <div className="row pl10 pr10 mb5">
                <div className="col-50 no-gutter mb20">
                  <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
                  <Text className="col-50 mb0-18" type="sdt" align="right" label="Phải thu tiền (đ):" value={String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.tienPhaiThuNhaNuocQDGQ)} />
                  <Text className="col-50 mb0-18" type="sdt" align="right" label="Phải thu đất (m2):" value={String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.datPhaiThuNhaNuocQDGQ)} />
                </div>
                <div className="col-50 no-gutter mb20">
                  <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
                  <Text className="col-50 mb0-18" type="sdt" align="right" label="Phải trả tiền (đ):" value={String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.tienPhaiTraCongDanQDGQ)} />
                  <Text className="col-50 mb0-18" type="sdt" align="right" label="Phải trả đất (m2):" value={String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.datPhaiTraCongDanQDGQ)} />
                </div>
                <div className="col-100 no-gutter">
                  <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý hành chính</p>
                  <Text className="col-25 mb0-18" type="sdt" label="Tổng số người:" value={String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.tongSoNguoiXuLyHanhChinh)} />
                  <Text className="col-25 mb0-18" type="sdt" label="Số người đã bị xử lý:" value={String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.soNguoiDaBiXuLyHanhChinh)} />
                  <Text className="col-25 mb0-18" label="Số người được trả lại quyền lợi:" value={String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.soNguoiDuocTraLaiQuyenLoi)} />
                </div>
              </div>
            </div>
          </ShowIf>

          <ShowIf condition={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.theoDoiThucHien}>
            <div className="col-100 no-gutter">
              <div className="pt5 pb15">
                <span className="line-border"></span>
              </div>
              <div className="col-100 no-gutter mt5 pb5">
                <h2 className="title-12 mb15">Theo dõi thực hiện</h2>
                <div className="row pl10 pr10 mb15">
                  <Text className="col-25 mb0-18" label="Kết quả thực hiện:" value={ketQuaThucHien.length > 0 ? ketQuaThucHien[0].ten : ''} />
                  <Text className="col-25 mb0-18" label="Kết quả thực hiện khác:" value={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaThucHienKhac ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.ketQuaThucHienKhac : ''} />
                </div>
                <div className="row pl10 pr10">
                  <div className="col-100 no-gutter mb20">
                    <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
                    <Text className="col-25 mb0-18" type="sdt" align="right" label="Phải thu tiền (đ):" value={String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.tienPhaiThuNhaNuoc)} />
                    <Text className="col-25 mb0-18" type="sdt" align="right" label="Phải thu đất (m2):" value={String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.datPhaiThuNhaNuoc)} />
                    <Text className="col-25 mb0-18" type="sdt" align="right" label="Đã thu tiền (đ):" value={String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.tienDaThuNhaNuoc)} />
                    <Text className="col-25 mb0-18" type="sdt" align="right" label="Đã thu đất (m2):" value={String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.datDaThuNhaNuoc)} />
                  </div>
                  <div className="col-100 no-gutter">
                    <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
                    <Text className="col-25 mb0-18" type="sdt" align="right" label="Phải trả tiền (đ):" value={String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.tienPhaiTraCongDan)} />
                    <Text className="col-25 mb0-18" type="sdt" align="right" label="Phải trả đất (m2):" value={String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.datPhaiTraCongDan)} />
                    <Text className="col-25 mb0-18" type="sdt" align="right" label="Đã trả tiền (đ):" value={String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.tienDaTraCongDan)} />
                    <Text className="col-25 mb0-18" type="sdt" align="right" label="Đã trả đất (m2):" value={String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.datDaTraCongDan)} />
                  </div>
                </div>
              </div>
            </div>
          </ShowIf>

          <ShowIf condition={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.giaoCoQuanDieuTra}>
            <div className="col-100 no-gutter">
              <div className="col-100 no-gutter pt5 pb15">
                <span className="line-border"></span>
              </div>
              <div className="col-100 no-gutter mt5 pb5">
                <h2 className="title-12 mb15">Chuyển cơ quan điều tra(Nếu có)</h2>
                <div className="row pl10 pr10">
                  <Text className="col-25 mb0-18" label="Tên cơ quan:" value={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.coQuanDieuTraInfo ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.coQuanDieuTraInfo.ten : ''} />
                  <Text className="col-25 mb0-18" label="Số vụ:" value={String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.soVuGiaoCoQuanDieuTra)} />
                  <Text className="col-25 mb0-18" label="Số đối tượng:" value={String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.soDoiTuongGiaoCoQuanDieuTra)} />
                </div>
              </div>
            </div>
          </ShowIf>

          <ShowIf condition={this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.khoiTo}>
            <div className="col-100 no-gutter">
              <div className="col-100 no-gutter pt5 pb15">
                <span className="line-border"></span>
              </div>
              <div className="col-100 no-gutter mt5">
                <h2 className="title-12 mb15">Khởi tố</h2>
                <div className="row pl10 pr10">
                  <div className="col-50 no-gutter">
                    <Text className="col-50 mb0-18" label="Số vụ:" value={String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.soVuBiKhoiTo)} />
                    <Text className="col-50 mb0-18" label="Số đối tượng:" value={String(this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo.soDoiTuongBiKhoiTo)} />
                  </div>
                </div>
              </div>
            </div>
          </ShowIf>

          <ShowIf condition={ketQuaGiaiQuyetDon.length > 0}>
            <div className="col-100 mt5 no-gutter">
              <h2 className="title-12 mb10">Tiến độ giải quyết</h2>
              <div className="row pl10 pr10">
                <p className="attach-file-description mb10 pl5 pr5">Tiến độ giải quyết cho biết giai đoạn giải quyết hiện tại của đơn</p>
                <Text className="col-25" label='' value={ketQuaGiaiQuyetDon.length > 0 ? ketQuaGiaiQuyetDon[0].ten : ''} />
              </div>
            </div>
          </ShowIf>

          <div className="container-filedinhkem">
            <ContainerFileDinhKem label="Danh sách văn bản xử lý" hideDescription={true} bindValidator={this} dataShow={this.props.listTaiLieuVanThuGiaiQuyetDon} disableAttachFile={true} />
          </div>
        </div>
      </section>
    );
  }
}

KetQuaLapDuThaoCanBo.defaultProps = {
  dataKetLuanNoiDungKhieuNai: [],
  dataKetQuaThucHien: [],
  ketQuaGiaiQuyetDon: []
}

let bindStateToProps = state => {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    dataKetQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  }
}

export default connect(bindStateToProps)(KetQuaLapDuThaoCanBo);


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien/KetQuaLapDuThaoCanBo.jsx